<template>
    <v-container>
        <parliamentarian-position url="HistoricalInformation/PrimeMinisters" pageHeader="true" header="Prime ministers"></parliamentarian-position>
    </v-container>
</template>
<script>
import ParliamentarianPosition from './ParliamentarianPosition.vue'

export default {
    data() {
        return {
            title: 'Prime Ministers'
        }
    },
    components: {
        ParliamentarianPosition
    }
}
</script>
<style scoped>
    .v-datatable {
        margin-bottom: 1rem;
    }
    h2 {
        margin-bottom: 1rem;
    }
</style>